import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Product from './pages/Products';
import Home from './pages/Home';
import About from './pages/about';
import Contact from './pages/Contact';
import Service from './pages/service';
import ProductsInfo from './pages/productsInfo'
import MedicineInfo from './pages/medicine'
import ContaimentInfo from './pages/Contaiment'
import ContactUs from './pages/ContactUs'
import History from './pages/historySection'


 function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Home />} />
          <Route path="product" element={<Product />} />
          <Route path="productsInfo" element={<ProductsInfo />} />
          <Route path="MedicineInfo" element={<MedicineInfo />} />
          <Route path="Contaiment" element={<ContaimentInfo />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="Service" element={<Service />} />
          <Route path="ContactUs" element={<ContactUs />} />
          <Route path="History" element={<History />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router/>
  </React.StrictMode>
);


// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
